module.exports = __webpack_public_path__ + "static/media/coca-cola.ef79cd1f.jpg";